<script lang="ts">
  import IntegratedTooltipIcon from "@shared/svelte/Components/IntegratedTooltipIcon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  import type { Distributor } from "@shared/types/Distributor";
  import type { ProductCardDistributorInfo } from "@shared/types/ProductLine";

  export let distributor: Distributor | ProductCardDistributorInfo;
  export let addComma: boolean = false;
  export let extraTextClasses: string = "";
  export let useTrackClick: boolean = false;
  export let targetObjectType: string = null;
</script>

<span class="fizz-flex-row-inline-4">
  <IntegratedTooltipIcon {distributor} />
  <UIRouterLink
    stateName={"layout.product_listing"}
    params={{ distributors: distributor.id }}
    classes="cursor-pointer distributor-search-link notranslate {extraTextClasses}"
    {useTrackClick}
    {targetObjectType}
  >
    {`${distributor.name}${addComma ? ", " : ""}`}
  </UIRouterLink>
</span>
